<template>
     <div class="opportunities">
        <div v-if="!loading">
            <p v-if="selectedJob && selectedJob.opportunities && selectedJob.opportunities.length">Oportunidades ({{selectedJob.opportunities.length}})</p>
            <div class="list" v-if="selectedJob && selectedJob.opportunities && selectedJob.opportunities.length">
                <Opportunity :opportunity="contract" :key="contract.id" v-for="contract in selectedJob.opportunities" :customerId="customerId" />
            </div>
            <div v-else class="opportunities-empty">
                <img src="/static/images/searching.svg" alt="Procurando oportunidades">
                <p>Nenhuma solicitação em andamento!</p>
            </div>
        </div>
        <div class="opportunities-loading" v-else>
            <v-progress-circular
                :size="30"
                :width="4"
                color="blue"
                indeterminate
            ></v-progress-circular>
        </div>
    </div>
</template>

<script>
import Opportunity from '../Opportunity.vue';

export default {
    components: { Opportunity },

    props: {
        customerId: {
            type: Number,
            required: true
        },
        selectedJob: {
            type: Object,
            required: true
        },
        loading: {
            type: Boolean,
            required: true
        }
    },
}
</script>

<style scoped>
    p {
        margin: 0;
    }

    .opportunities {
        width: 100%;
        display: flex;
        flex-direction: column;
        /* box-shadow: 0 5px 20px 0 rgba(0,0,0, 0.15); */
        padding: 15px;
        border-radius: 5px;
        background-color: var(--white-color);
        gap: 10px;
        flex: 1;
    }

    .list {
        display: flex;
        flex-direction: column;
        gap: 15px;
    }

    .opportunities > div > p {
        font-size: 18px;
        color: var(--primary-color);
        font-weight: bold;
        margin-bottom: 15px;
    }

    .opportunities-empty {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        text-align: start;
        padding: 20px;
    }

    .opportunities-loading {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
    }

    .opportunities-empty img {
        width: 75px;
        height: 75px;
    }

    .opportunities-empty p {
        font-size: 18px;
        color: var(--primary-color);
        font-weight: bold;
        margin-left: 20px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Prospection/Cards/OpportunitiesCard.vue